import CreatePageSkeleton from '../CreatePageSkeleton/CreatePageSkeleton';
import DetailPageSkeleton from '../DetailPageSkeleton/DetailPageSkeleton';
import ListPageSkeleton from '../ListPageSkeleton/ListPageSkeleton';

import type { PageSkeletonProps } from './types';

/**
 * variant에 따라 적절한 페이지 스켈레톤을 렌더링하는 컴포넌트
 *
 * @example
 * <PageSkeleton variant="list" />
 *
 * @example
 * <PageSkeleton variant="detail" detailPageSkeletonProps={{ sectionsCount: 5 }} />
 *
 * @example
 * <PageSkeleton variant="create" createPageSkeletonProps={{ formContentHeight: 400 }} />
 */
export default function PageSkeleton({
  createPageSkeletonProps,
  detailPageSkeletonProps,
  listPageSkeletonProps,
  variant,
}: PageSkeletonProps) {
  switch (variant) {
    case 'create':
      return <CreatePageSkeleton {...createPageSkeletonProps} />;
    case 'detail':
      return <DetailPageSkeleton {...detailPageSkeletonProps} />;
    case 'list':
      return <ListPageSkeleton {...listPageSkeletonProps} />;
  }
}
